let originalPrices = {};

function storeOriginalPrices() {
  const priceContainers = document.querySelectorAll(".price__regular, .price__sale");
  priceContainers.forEach((container) => {
    const priceElements = container.querySelectorAll(".price-item");
    priceElements.forEach((priceElement) => {
      if (priceElement && priceElement.textContent) {
        const priceText = priceElement.textContent.trim();
        const currencySymbolMatch = priceText.match(/[^0-9.,\s]/);
        const currencySymbol = currencySymbolMatch ? currencySymbolMatch[0] : "";
        const price = parseFloat(priceText.replace(/[^\d.]/g, ""));
        priceElement.dataset.originalPrice = price;
        priceElement.dataset.currencySymbol = currencySymbol;
      }
    });
  });
}

storeOriginalPrices();

function hidePriceContainers() {
  const priceContainers = document.querySelectorAll(".price__container");
  priceContainers.forEach((container) => {
    container.style.visibility = "hidden";
  });
}

hidePriceContainers();

function updatePrices(isVATExclusive) {
  const exVatLabelText = document.getElementById("vat-toggle").dataset.exvatLabelText;
  const vatLabelText = document.getElementById("vat-toggle").dataset.vatLabelText;

  // Select price containers, excluding those that should not change
  const priceContainers = document.querySelectorAll(
    ".price__regular:not(.cart-notification .price__regular):not(.related-product-carousel .price__regular):not(.cart-page .price__regular), " +
    ".price__sale:not(.cart-notification .price__sale):not(.related-product-carousel .price__sale):not(.cart-page .price__sale)"
  );

  priceContainers.forEach((container) => {
    const priceElements = container.querySelectorAll(".price-item");
    priceElements.forEach((priceElement) => {
      if (priceElement && priceElement.dataset.originalPrice) {
        const originalPrice = parseFloat(priceElement.dataset.originalPrice);
        const currencySymbol = priceElement.dataset.currencySymbol;
        const price = isVATExclusive ? originalPrice * 1.2 : originalPrice;
        const formattedPrice = price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        priceElement.textContent = currencySymbol + formattedPrice;
      }
    });

    const vatLabel = container.querySelector(".vat");
    if (vatLabel) {
      vatLabel.textContent = isVATExclusive ? vatLabelText : exVatLabelText;
    }
  });

  // Handle special containers
  const newPriceContainers = document.querySelectorAll(
    ".cart-notification .price__regular, .cart-notification .price__sale, " +
    ".related-product-carousel .price__regular, .related-product-carousel .price__sale, " +
    ".cart-page .price__regular, .cart-page .price__sale, .price__rrp"
  );

  newPriceContainers.forEach((container) => {
    const exVatElements = container.querySelectorAll(".ex-vat");
    const incVatElements = container.querySelectorAll(".inc-vat");

    exVatElements.forEach((exVatElement) => {
      exVatElement.style.display = isVATExclusive ? "none" : "flex";
    });

    incVatElements.forEach((incVatElement) => {
      incVatElement.style.display = isVATExclusive ? "flex" : "none";
    });
  });
}

function checkURLParameters() {
  const urlParams = new URLSearchParams(window.location.search);
  const forceIncVAT = urlParams.has("inc-vat");

  // Check localStorage and handle the case when it's null
  let isVATExclusive = localStorage.getItem("vatExclusive");

  // If no VAT preference exists in localStorage, default to VAT-inclusive
  if (isVATExclusive === null) {
    isVATExclusive = true;  // Default to VAT-inclusive
    localStorage.setItem("vatExclusive", "true"); // Store the default value as 'true'
  } else {
    // Convert the string to a boolean
    isVATExclusive = isVATExclusive === "true";
  }

  // If URL forces VAT-inclusive (inc-vat), overwrite localStorage value
  if (forceIncVAT) {
    isVATExclusive = true;
  }

  // Update the VAT toggle and prices
  document.getElementById("vat-checkbox").checked = isVATExclusive;
  updatePrices(isVATExclusive);
  updateToggleLabels(isVATExclusive);

  // Allow user override after initial load
  window.addEventListener("load", () => {
    document.getElementById("vat-checkbox").addEventListener("change", toggleVAT);
  });
}

function updateToggleLabels(isVATExclusive) {
  const toggleLabel = document.getElementById("toggle-label"); 
  const exVatLabelText = document.getElementById("vat-toggle").dataset.exvatLabelText; 
  const vatLabelText = document.getElementById("vat-toggle").dataset.vatLabelText;     

  toggleLabel.textContent = isVATExclusive ? vatLabelText : exVatLabelText;

  if (isVATExclusive) {
    document.getElementById("vat-toggle").classList.add("slider-right"); 
  } else {
    document.getElementById("vat-toggle").classList.remove("slider-right");
  }
}

function showPriceContainers() {
  let priceContainers = document.querySelectorAll(".price__container");
  priceContainers.forEach((container) => {
    container.style.visibility = "visible";
  });
}

function toggleVAT() {
  const isChecked = document.getElementById("vat-checkbox").checked;

  localStorage.setItem("vatExclusive", isChecked.toString());
  updatePrices(isChecked);
  updateToggleLabels(isChecked);
}

storeOriginalPrices();
hidePriceContainers();

window.addEventListener("load", function () {
  storeOriginalPrices(); // Ensure original prices are stored first
  checkURLParameters();
  showPriceContainers();
});

// When selecting a filter (URL query gets appended) set the VAT label based on current VAT filter
window.navigation.addEventListener("navigate", (event) => {
  if (!document.getElementById('vat-checkbox').checked) {
    document.querySelectorAll('.vat').forEach((vatLabel) => {
      vatLabel.innerHTML = 'excl. VAT'
    });
  }
})

document.getElementById("vat-checkbox").addEventListener("change", toggleVAT);